import { useUsers } from '../../hooks/useUsers';

interface UserSelectProps {
  label: string;
  selectedEmails: string[];
  onChange: (emails: string[]) => void;
  hint?: string;
  excludeEmails?: string[];
}

export function UserSelect({ label, selectedEmails, onChange, hint, excludeEmails = [] }: UserSelectProps) {
  const { data: users, isLoading } = useUsers();

  const filteredUsers = users?.filter(u => !excludeEmails.includes(u.email));

  const toggleEmail = (email: string) => {
    if (selectedEmails.includes(email)) {
      onChange(selectedEmails.filter(e => e !== email));
    } else {
      onChange([...selectedEmails, email]);
    }
  };

  return (
    <div>
      <label style={{ display: 'block', fontWeight: 600, fontSize: '0.875rem', marginBottom: 'var(--spacing-xs)' }}>
        {label}
      </label>
      <div
        style={{
          border: '1px solid var(--color-border)',
          borderRadius: 'var(--radius-md)',
          maxHeight: '180px',
          overflowY: 'auto',
          padding: 'var(--spacing-xs)',
        }}
      >
        {isLoading ? (
          <p
            style={{ padding: 'var(--spacing-sm)', color: 'var(--color-text-light)', fontSize: '0.875rem', margin: 0 }}
          >
            Loading users...
          </p>
        ) : !filteredUsers || filteredUsers.length === 0 ? (
          <p
            style={{ padding: 'var(--spacing-sm)', color: 'var(--color-text-light)', fontSize: '0.875rem', margin: 0 }}
          >
            No users found
          </p>
        ) : (
          filteredUsers.map(user => (
            <label
              key={user.id}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 'var(--spacing-sm)',
                padding: 'var(--spacing-xs) var(--spacing-sm)',
                cursor: 'pointer',
                borderRadius: 'var(--radius-sm)',
                fontSize: '0.875rem',
              }}
            >
              <input
                type="checkbox"
                className="form-check-input"
                checked={selectedEmails.includes(user.email)}
                onChange={() => toggleEmail(user.email)}
              />
              <span>{user.name || user.email}</span>
            </label>
          ))
        )}
      </div>
      {hint && (
        <p className="text-muted" style={{ fontSize: '0.8rem', margin: 'var(--spacing-sm) 0 0' }}>
          {hint}
        </p>
      )}
    </div>
  );
}
